(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('RecapObjectsController', RecapObjectsController);

    RecapObjectsController.$inject = ['$state', 'LicenceCode', 'Vendor', 'pagingParams', 'paginationConstants'];

    function RecapObjectsController($state, LicenceCode, Vendor, pagingParams, paginationConstants) {
        var vm = this;

        vm.charToSearch = pagingParams.search;

        vm.activeLicence = [];
        vm.vendors = [];

        vm.vendor = [];
        var vendor = localStorage.getItem("licence-code-detail");
        if(vendor != null && vendor != "null" && vendor != undefined){
            vm.vendor = JSON.parse(vendor);
        }

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        Vendor.query(function (result) {
            var all = {
                id: -1,
                name: "ALL",
                link: null
            };
            vm.vendors = result;
            vm.vendors.unshift(all);
        });

        vm.loadAll = function() {
            var body = {
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                page: pagingParams.page -1,
                size: vm.itemsPerPageChosen,
                query: vm.charToSearch
            };

            LicenceCode.activeLicence(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.activeLicence = [];
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.activeLicence = data;
            }

            function onError() {}
        };

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        vm.reloadLicences = function() {
            localStorage.setItem("licence-code-detail", JSON.stringify(vm.vendor));
            vm.loadAll();
        };

        vm.loadAll();
    }
})();
